'use strict'

var sizes = require('css-font-size-keywords')

module.exports = {
	isSize: function isSize(value) {
		return /^[\d\.]/.test(value)
			|| value.indexOf('/') !== -1
			|| sizes.indexOf(value) !== -1
	}
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-font/lib/util.js
// module id = wGdQ
// module chunks = 0